import { render, staticRenderFns } from "./ViewAbwesenheit.vue?vue&type=template&id=63b8f05c&scoped=true"
import script from "./ViewAbwesenheit.vue?vue&type=script&lang=js"
export * from "./ViewAbwesenheit.vue?vue&type=script&lang=js"
import style0 from "./ViewAbwesenheit.vue?vue&type=style&index=0&id=63b8f05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8f05c",
  null
  
)

export default component.exports